module.exports = __webpack_public_path__ + "static/presenting-2-995e6b7ed48b11f591cba4fd15893f75.jpg";